import { render, staticRenderFns } from "./FollowListItem.vue?vue&type=template&id=7910f896&scoped=true&"
import script from "./FollowListItem.vue?vue&type=script&lang=js&"
export * from "./FollowListItem.vue?vue&type=script&lang=js&"
import style0 from "./FollowListItem.vue?vue&type=style&index=0&id=7910f896&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7910f896",
  null
  
)

export default component.exports